import { IDataTableHeader } from '@typings/components';

export const BIDDER_USERS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Name',            align: 'left' },
  { label: 'Status',          align: 'left' },
  { label: 'Location',        align: 'left' },
  { label: 'Registered Date', align: 'center' },
];

export const USERS_ACTIVITY_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Bid',     align: 'left' },
  { label: 'Auction', align: 'left' },
  { label: 'Notes',   align: 'left' },
];

export const COMPLAINT_USERS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Date',    align: 'left' },
  { label: 'Auction', align: 'left' },
  { label: 'From',    align: 'left' },
];
